module.exports = __webpack_public_path__ + "static/media/bi_emblem_black_m.b0a2f8c1.png";